import authForm from './main/auth_form/controller';
// import initFooter from './main/footer/controller';
import initCarousel from './main/carousel/controller';

BX.ready(function(){
    authForm();
    // initFooter();
    initCarousel();
});